import React from 'react';
import { LinkButton } from '../../button/Button';
import { getSocialSignInUrl } from '../../../../../components/form/registration/registrationUtils';

// import { SignupFormFields } from './SignupFormFieldsRoma'; - switch this import to use Roma fields
import { SignupFormFields } from './SignupFormFields';
import { sendRegisterSubmitEvent } from '../../../../../../../client/analytics/dataLayerService';
import { REGISTRATION_SOURCES } from '../../../../../../../client/analytics/dataLayerConstants';
import google from './google.svg';
import apple from './apple.svg';
var SignupLogo = function SignupLogo(_ref) {
  var icon = _ref.icon;
  return /*#__PURE__*/React.createElement("img", {
    src: icon,
    className: "signup-button-logo",
    alt: ""
  });
};
var LegalLink = function LegalLink(_ref2) {
  var url = _ref2.url,
    children = _ref2.children;
  return /*#__PURE__*/React.createElement("a", {
    className: "LegalLink",
    href: url,
    target: "_blank",
    rel: "noopener noreferrer"
  }, children);
};
export var SignupForm = function SignupForm(_ref3) {
  var buttonText = _ref3.buttonText;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "oauth-buttons"
  }, /*#__PURE__*/React.createElement(LinkButton, {
    onClick: function onClick() {
      return sendRegisterSubmitEvent(REGISTRATION_SOURCES.OAUTH_GOOGLE);
    },
    href: getSocialSignInUrl('google')
  }, /*#__PURE__*/React.createElement(SignupLogo, {
    icon: google
  }), " Sign up with Google"), /*#__PURE__*/React.createElement(LinkButton, {
    onClick: function onClick() {
      return sendRegisterSubmitEvent(REGISTRATION_SOURCES.OAUTH_APPLE);
    },
    href: getSocialSignInUrl('apple')
  }, /*#__PURE__*/React.createElement(SignupLogo, {
    icon: apple
  }), " Sign up with Apple")), /*#__PURE__*/React.createElement("hr", null), /*#__PURE__*/React.createElement("div", {
    className: "SignupForm"
  }, /*#__PURE__*/React.createElement("h3", {
    className: "signup-heading"
  }, "Sign up with email"), /*#__PURE__*/React.createElement(SignupFormFields, {
    buttonText: buttonText
  }), /*#__PURE__*/React.createElement("div", {
    className: "signup-footer"
  }, "This site is protected by reCAPTCHA and the Google", ' ', /*#__PURE__*/React.createElement(LegalLink, {
    url: "https://policies.google.com/terms"
  }, "terms of service"), " and", ' ', /*#__PURE__*/React.createElement(LegalLink, {
    url: "https://policies.google.com/privacy"
  }, "privacy policy"), " apply")));
};